import { render } from "./AppSpacer.vue?vue&type=template&id=4ef7f3d9&scoped=true"
import script from "./AppSpacer.vue?vue&type=script&lang=js"
export * from "./AppSpacer.vue?vue&type=script&lang=js"

import "./AppSpacer.vue?vue&type=style&index=0&id=4ef7f3d9&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef7f3d9"]])

export default __exports__